import { render, staticRenderFns } from "./DummyView.vue?vue&type=template&id=4b992329&"
import script from "./DummyView.vue?vue&type=script&lang=js&"
export * from "./DummyView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports